import { render } from "./activity-correction.vue?vue&type=template&id=1f3ef6fd&scoped=true&ts=true"
import script from "./activity-correction.vue?vue&type=script&lang=ts"
export * from "./activity-correction.vue?vue&type=script&lang=ts"

import "./activity-correction.vue?vue&type=style&index=0&id=1f3ef6fd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3ef6fd"]])

export default __exports__